import type { Grade } from '../types/api';

export const GRADE_LABEL: Record<Grade, string> = {
  A: 'Verified',
  B: 'Indicative',
  C: 'Placeholder',
};

export const GRADE_TONE: Record<Grade, 'good' | 'amber' | 'bad'> = { A: 'good', B: 'amber', C: 'bad' };

export function baseGrade(display: string): Grade {
  const g = display.replace('*', '');
  return g === 'A' || g === 'B' || g === 'C' ? g : 'C';
}
